import * as moment from "moment";
import Vue from "vue";
import { Component } from "vue-property-decorator";

import { IRecentlyVisitedPage, RecentlyVisitedPages } from "../../scripts/common/ah.mb.common.stored-stack";


@Component
export default class RecentItemsList extends Vue {

    recentItems: IRecentlyVisitedPage[] = [];
    recentItemsStore: RecentlyVisitedPages;

    updateRecentItemsList() {
        this.recentItems = this.recentItemsStore.stack.getItems();
    }

    mounted() {

        // Load recent model list
        this.recentItemsStore = new RecentlyVisitedPages();
        this.updateRecentItemsList();

        // On route change, update the list
        this.$router.beforeEach((to, from, next) => {
            // Todo: Get the list of pages from the router
            this.updateRecentItemsList();
            next();
        });

    }

    recentItemClick(item: IRecentlyVisitedPage) {
        $("#recent-items-control-sidebar").removeClass("control-sidebar-open");
        this.recentItemsStore.navigateToRecentItem(item, this.$router);
    }

    getVisitedDateString(item: IRecentlyVisitedPage): string {
        if (item.visitedDate) {
            const dateObj = moment(item.visitedDate);
            return dateObj.format("MMMM Do, h:mm a");
        }
        return "";
    }


}


// WEBPACK FOOTER //
// ./ClientApp/components/recent-items-list/recent-items-list.ts